import src from "IMAGE";
export default { src, width: 500, height: 69, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AI+Oj46hoKHXnp2enZmYmZKsq6ylrq2up7CusKi6uLqzSrAUs9bAiqIAAAAASUVORK5CYII="};
